import { createFileRoute } from "@tanstack/react-router";
import DashboardOverview from "@/pages/dashboard";

export const Route = createFileRoute("/dashboard/")({
  component: DashboardOverview,
});
